import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3","key":"svg-0"}],["path",{"d":"M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3","key":"svg-1"}],["path",{"d":"M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7","key":"svg-2"}],["path",{"d":"M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1","key":"svg-3"}],["path",{"d":"M17 12h.01","key":"svg-4"}],["path",{"d":"M13 12h.01","key":"svg-5"}]]

const IconForms = createReactComponent('outline', 'forms', 'Forms', __iconNode);

export default IconForms;